import React, { useContext } from 'react';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Spinner from './components/Spinner';
import Navbar from './components/Navbar/Navbar';
import SecurityNotice from './components/Notices/SecurityNotice.js';
import ConfirmAccount from './components/ConfirmAccount';
import Register from './components/Register/Register';
import Login from './components/Login/Login';
import Logout from './components/Logout';
import Dashboard from './components/Dashboard/Dashboard';
import HomePage from './components/HomePage/HomePage';
import Profile from './components/Profile/Profile';
import Send from './components/Send/Send';
import Receive from './components/Receive/Receive';
import Transactions from './components/Transactions/Transactions';
import TransactionsUtxos from './components/TransactionsUtxos';
import Smartnodes from './components/Smartnodes/Smartnodes';
import SwapFunds from './components/SwapFunds/SwapFunds';
import FundsDistribution from './components/FundsDistribution/FundsDistribution';
import Footer from './components/Footer';
import SessionGallery from './components/SessionGames/SessionGallery';
import AddGame from './components/SessionGames/AddGame';

/////////////////// Juegos ////////////////////////
// 1 dado
import MenelDie from './components/Games/MenelDie/MenelDie'; 
// 2 dado
import MenelTwoDice from './components/Games/MenelTwoDice/MenelTwoDice'; 
// Menel-duel-dice
import MenelDuelDice from './components/Games/MenelDuelDice/MenelDuelDice';

import BullfighterOrBull from './components/Games/BullfighterOrBull/BullfighterOrBull'; 
import BlackJack from './components/Games/BlackJack/BlackJack'; 
import EuropeanBlackJack from './components/Games/EuropeanBlackJack/EuropeanBlackJack'; 
import BlackJackSwitch from './components/Games/BlackJackSwitch/BlackJackSwitch'; 
import BaccaratGame from './components/Games/Baccarat/BaccaratGame'; 
import FiveCardDraw from './components/Games/FiveCardDraw/FiveCardDraw';
import WarGame from './components/Games/WarGame/WarGame';
import RedDog from './components/Games/RedDog/RedDog';
import ChinesePoker from './components/Games/ChinesePoker/ChinesePoker';
import CaribbeanStudPoker from './components/Games/CaribbeanStudPoker/CaribbeanStudPoker';
import CardPoker from './components/Games/CardPoker/CardPoker';
import PaiGowPoker from './components/Games/PaiGowPoker/PaiGowPoker';
import NumericSlotMachine from './components/Games/NumericSlotMachine/NumericSlotMachine';
import GoldenSevenSlots from './components/Games/GoldenSevenSlots/GoldenSevenSlots';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="d-flex flex-column min-vh-100">
          <Navbar />
          <div className="flex-grow-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route
                path="/register"
                element={<ProtectedRoute redirectTo="/dashboard" component={Register} authRequired={false} />}
              />
               <Route
                path="/securitynotice"
                element={<ProtectedRoute redirectTo="/dashboard" component={SecurityNotice} authRequired={false} />}
              />
              <Route path="/confirm" element={<ConfirmAccount />} />
              <Route
                path="/login"
                element={<ProtectedRoute redirectTo="/dashboard" component={Login} authRequired={false} />}
              />
              <Route
                path="/dashboard"
                element={<ProtectedRoute redirectTo="/login" component={Dashboard} authRequired={true} />}
              />
              <Route
                path="/fundsdistribution"
                element={<ProtectedRoute redirectTo="/login" component={FundsDistribution} authRequired={true} />}
              />
              <Route
                path="/swapfunds"
                element={<ProtectedRoute redirectTo="/login" component={SwapFunds} authRequired={true} />}
              />
              <Route
                path="/send"
                element={<ProtectedRoute redirectTo="/login" component={Send} authRequired={true} />}
              />
              <Route
                path="/logout"
                element={<Logout />}
              />
              <Route
                path="/transactions"
                element={<ProtectedRoute redirectTo="/login" component={Transactions} authRequired={true} />}
              />
              <Route
                path="/utxos"
                element={<ProtectedRoute redirectTo="/login" component={TransactionsUtxos} authRequired={true} />}
              />
              <Route
                path="/receive"
                element={<ProtectedRoute redirectTo="/login" component={Receive} authRequired={true} />}
              />
              <Route
                path="/smartnodes"
                element={<Smartnodes />}
              />
              <Route
                path="/profile"
                element={<ProtectedRoute redirectTo="/login" component={Profile} authRequired={true} />}
              />
              <Route
                path="/add-game"
                element={<ProtectedRoute redirectTo="/login" component={AddGame} authRequired={true} />}
              />
              <Route
                path="/sessions"
                element={<ProtectedRoute redirectTo="/login" component={SessionGallery} authRequired={true} />}
              />
              <Route
                path="/menel-die"
                element={<ProtectedRoute redirectTo="/login" component={MenelDie} authRequired={true} />}
              />
              <Route
                path="/2menel-die"
                element={<ProtectedRoute redirectTo="/login" component={MenelTwoDice} authRequired={true} />}
              />
              <Route
                path="/play-menel-duel-dice"
                element={<ProtectedRoute redirectTo="/login" component={MenelDuelDice} authRequired={true} />}
              />
              <Route
                path="/bullfighter-or-bull"
                element={<ProtectedRoute redirectTo="/login" component={BullfighterOrBull} authRequired={true} />}
              />
              <Route
                path="/blackjack/play"
                element={<ProtectedRoute redirectTo="/login" component={BlackJack} authRequired={true} />}
              />
              <Route
                path="/european-blackjack/play"
                element={<ProtectedRoute redirectTo="/login" component={EuropeanBlackJack} authRequired={true} />}
              />
              <Route
                path="/blackjackswitch/play"
                element={<ProtectedRoute redirectTo="/login" component={BlackJackSwitch} authRequired={true} />}
              />
              <Route
                path="/baccarat/play"
                element={<ProtectedRoute redirectTo="/login" component={BaccaratGame} authRequired={true} />}
              />
              <Route
                path="/FiveCardDraw"
                element={<ProtectedRoute redirectTo="/login" component={FiveCardDraw} authRequired={true} />}
              />
              <Route
                path="/war/play"
                element={<ProtectedRoute redirectTo="/login" component={WarGame} authRequired={true} />}
              />
              <Route
                path="/red-dog/play"
                element={<ProtectedRoute redirectTo="/login" component={RedDog} authRequired={true} />}
              />
              <Route
                path="/chinese-poker/play"
                element={<ProtectedRoute redirectTo="/login" component={ChinesePoker} authRequired={true} />}
              />
              <Route
                path="/caribbean-stud/play"
                element={<ProtectedRoute redirectTo="/login" component={CaribbeanStudPoker} authRequired={true} />}
              />
              <Route
                path="/card-poker/play"
                element={<ProtectedRoute redirectTo="/login" component={CardPoker} authRequired={true} />}
              />
              <Route
                path="/pai-gow/play"
                element={<ProtectedRoute redirectTo="/login" component={ PaiGowPoker} authRequired={true} />}
              />
              <Route
                path="/playNumericSlotMachine"
                element={<ProtectedRoute redirectTo="/login" component={ NumericSlotMachine} authRequired={true} />}
              />
              <Route
                path="/playGoldenSevenSlots"
                element={<ProtectedRoute redirectTo="/login" component={GoldenSevenSlots} authRequired={true} />}
              />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}


const ProtectedRoute = ({ component: Component, authRequired, redirectTo }) => {
  const { auth, loading } = useContext(AuthContext);

  // cargando la autenticación, no hacer nada
  if (loading) {
    return <Spinner />;
  }

  if (authRequired && !auth.token) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!authRequired && auth.token) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Component />;
};

// Componente ProtectedRoute para manejar la lógica de autenticación
/*const ProtectedRoute = ({ component: Component, authRequired, redirectTo }) => {
  const { auth } = useContext(AuthContext);

  console.log('Auth status:', auth);
  console.log('Auth token:', auth.token);

  if (authRequired && !auth.token) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!authRequired && auth.token) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Component />;
};*/

export default App;
